"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Slider = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Slider, _Component);

  var _super = _createSuper(Slider);

  /* istanbul ignore next */
  function Slider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Slider);
    _this = _super.call(this, props);
    _this.state = {
      value: props.value ? props.value : props.minValue,
      changing: false
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onMouseUp = _this.onMouseUp.bind((0, _assertThisInitialized2.default)(_this));
    _this.onMouseDown = _this.onMouseDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Slider, [{
    key: "handleChange",
    value: function handleChange(event) {
      var newValue = parseInt(event.target.value, 10);
      this.setState({
        value: newValue,
        changing: true
      });
      this.props.onChange(newValue);
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp() {
      document.removeEventListener('mouseup', this.onMouseUp);
      document.getElementsByTagName('body')[0].style.cursor = '';
      this.setState({
        changing: false
      });
      this.props.onDragEnd(this.state.value);
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown() {
      this.setState({
        changing: true
      });
      this.listenToMouseUp();
    }
  }, {
    key: "listenToMouseUp",
    value: function listenToMouseUp() {
      document.addEventListener('mouseup', this.onMouseUp);
      document.getElementsByTagName('body')[0].style.cursor = 'pointer';
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value >= nextProps.minValue && nextProps.value <= nextProps.maxValue) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          value = _this$state.value,
          changing = _this$state.changing;
      var _this$props = this.props,
          minValue = _this$props.minValue,
          maxValue = _this$props.maxValue,
          valueLabels = _this$props.valueLabels,
          largeValueLabels = _this$props.largeValueLabels,
          hideValueBar = _this$props.hideValueBar,
          step = _this$props.step,
          className = _this$props.className,
          disabled = _this$props.disabled;
      var classNames = (0, _classnames.default)('range-slider', disabled && 'disabled', valueLabels && 'show-value-labels', hideValueBar && 'hide-value-bar', largeValueLabels && 'large-value-labels', className && className);

      var renderValue = function renderValue() {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "range-value"
        }, value);
      };

      var trackWidth = 100 * (value - minValue) / (maxValue - minValue);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classNames
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "range-whole-track"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "range-track",
        style: {
          width: "".concat(trackWidth, "%")
        }
      }, valueLabels && renderValue()), /*#__PURE__*/_react.default.createElement("input", {
        className: "".concat(changing ? 'changing' : ''),
        value: value,
        min: minValue,
        max: maxValue,
        step: step,
        type: "range",
        onChange: this.handleChange,
        onMouseDown: this.onMouseDown
      }));
    }
  }]);
  return Slider;
}(_react.Component);

Slider.defaultProps = {
  step: 1,
  value: 0,
  minValue: 0,
  maxValue: Number.MAX_VALUE,
  valueLabels: false,
  hideValueBar: false,
  disabled: false,
  onChange: function onChange() {},
  onDragEnd: function onDragEnd() {}
};
Slider.propTypes = {
  value: _propTypes.default.number,
  minValue: _propTypes.default.number.isRequired,
  maxValue: _propTypes.default.number.isRequired,
  valueLabels: _propTypes.default.bool,
  largeValueLabels: _propTypes.default.bool,
  hideValueBar: _propTypes.default.bool,
  step: _propTypes.default.number,
  onChange: _propTypes.default.func,
  onDragEnd: _propTypes.default.func,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
var _default = Slider;
exports.default = _default;